import React from 'react';
import './styles.css';

class PhotoViewer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            imageSrc: props.imageSrc
        };

        this.closeGalleryCallback = props.closeGalleryCallback;
    }

    render() {
        const {imageSrc} = this.state;
        return (
            <div className='photoViewerMainContainer' onClick={(e) => this.closeGalleryCallback()}>
                <div className='photoViewerContainer' onClick={(e) => e.stopPropagation() }>
                    <img className='photoViewerImage' src={imageSrc}/>
                    <div className='photoViewerButtonContainer'>
                        <span onClick={(e) => this.closeGalleryCallback() }>Close</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default PhotoViewer;


// WEBPACK FOOTER //
// ./src/components/PhotoViewer/index.js